import axios, { AxiosResponse } from "axios";

export const updateCleSubscriptionCache = () => async (): Promise<AxiosResponse<boolean>> => {
	return await axios.post(`/api/v1/servicemessaging/cle-subscription-cache`);
};
